import { api } from "../App";
import { SET_ACCESS_ENTITY, SET_ACCESS_GROUP_DATA, SET_ACCESS_LOADING, SET_CHAPTERS_LIST } from "./types";
import { createNotification } from "../components/Notifications/Notifications";

export const getAccessChapters = () => async (dispatch) => {
  try {
    dispatch({ type: SET_ACCESS_LOADING, payload: true });
    const { data } = await api.get(`/access_control/chapters`);
    dispatch({ type: SET_CHAPTERS_LIST, payload: data });
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_ACCESS_LOADING, payload: false });
  }
};

export const getChapterEntity = (chapterId) => async (dispatch) => {
  try {
    dispatch({ type: SET_ACCESS_LOADING, payload: true });
    const { data } = await api.get(`/access_control/chapters/${chapterId}/entity`);
    dispatch({ type: SET_ACCESS_ENTITY, payload: data });
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_ACCESS_LOADING, payload: false });
  }
};

export const getChapterGroupData = (chapterId, roleId) => async (dispatch) => {
  try {
    dispatch({ type: SET_ACCESS_LOADING, payload: true });
    const { data } = await api.get(`/access_control/chapters/${chapterId}/role/${roleId}`);
    dispatch({ type: SET_ACCESS_GROUP_DATA, payload: data });
  } catch (ERR) {
    dispatch({ type: SET_ACCESS_GROUP_DATA, payload: null });
  } finally {
    dispatch({ type: SET_ACCESS_LOADING, payload: false });
  }
};

export const uploadChapterGroupData = (payload, chapterId, roleId) => async (dispatch) => {
  try {
    dispatch({ type: SET_ACCESS_LOADING, payload: true });
    await api.put(`/access_control/chapter/${chapterId}/role/${roleId}`, payload);
    createNotification('success', 'Изменения успешно сохранены');
    dispatch(getChapterGroupData(chapterId, roleId));
  } catch (ERR) {
  } finally {
    dispatch({ type: SET_ACCESS_LOADING, payload: false });
  }
};
